const ENV_ENUM = {
  alpha: 'alpha',
  delta: 'delta',
  staging: 'staging',
  customer: 'customer',
};

const ENV = import.meta.env.MODE;

const SELECTED_PORTAL = 'CallCenter';

const HOST_URL =
  ENV === ENV_ENUM.alpha
    ? 'https://admin-backend.alpha.bioflux.io'
    : ENV === ENV_ENUM.delta
      ? 'https://admin-backend.delta.bioflux.io'
      : ENV === ENV_ENUM.staging
        ? 'https://admin-backend.staging.biotricity.com'
        : 'https://admin-backend.customer.biotricity.com';

const SOCKET =
  ENV === ENV_ENUM.alpha
    ? 'https://sio.alpha.bioflux.io'
    : ENV === ENV_ENUM.delta
      ? 'https://sio.delta.bioflux.io'
      : ENV === ENV_ENUM.staging
        ? 'https://sio.staging.biotricity.com'
        : 'https://sio.customer.biotricity.com';

const LINK_REDIRECT_AWS =
  ENV === ENV_ENUM.alpha
    ? 'https://erp.alpha.bioflux.io/login'
    : ENV === ENV_ENUM.delta
      ? 'https://erp.delta.bioflux.io/login'
      : ENV === ENV_ENUM.staging
        ? 'https://erp.staging.biotricity.com/login/'
        : 'https://erp.customer.biotricity.com/login/';

const LINK_LOGOUT_AWS =
  ENV === ENV_ENUM.alpha
    ? 'https://login.alpha.bioflux.io/session/end'
    : ENV === ENV_ENUM.delta
      ? 'https://login.delta.bioflux.io/session/end'
      : ENV === ENV_ENUM.staging
        ? 'https://login.staging.biotricity.com/session/end'
        : 'https://login.customer.biotricity.com/session/end';

const LINK_REDIRECT_AWS_LOCAL = 'http://localhost:3001/login/';

const { VITE_GTM_KEY: GTM_KEY } = import.meta.env;

const ENV_DOMAIN =
  ENV === ENV_ENUM.alpha || ENV === ENV_ENUM.delta ? '.bioflux.io' : '.biotricity.com';

export {
  ENV,
  ENV_ENUM,
  SELECTED_PORTAL,
  HOST_URL,
  SOCKET,
  LINK_REDIRECT_AWS,
  LINK_LOGOUT_AWS,
  LINK_REDIRECT_AWS_LOCAL,
  GTM_KEY,
  ENV_DOMAIN,
};
